import React, { Component } from "react";
import moment from "moment";
import helperFunction from "../../Function/helperFunction";

export class InvoiceHtml extends Component {
  state = {
    a: [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ],
    b: [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ],
  };

  numToWordsDhiram = (n) => {
    if (n < 0)
        return false;
    
    let single_digit = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine']
    let double_digit = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen']
    let below_hundred = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']
    
    if (n === 0) return 'Zero';
    
    function translate(n) {
        let word = "";
        if (n < 10) {
            word = single_digit[n] + ' ';
        } else if (n < 20) {
            word = double_digit[n - 10] + ' ';
        } else if (n < 100) {
            let rem = translate(n % 10);
            word = below_hundred[(n - n % 10) / 10 - 2] + ' ' + rem;
        } else if (n < 1000) {
            word = single_digit[Math.trunc(n / 100)] + ' Hundred ' + translate(n % 100);
        } else if (n < 1000000) {
            word = translate(parseInt(n / 1000)).trim() + ' Thousand ' + translate(n % 1000);
        } else if (n < 1000000000) {
            word = translate(parseInt(n / 1000000)).trim() + ' Million ' + translate(n % 1000000);
        } else {
            word = translate(parseInt(n / 1000000000)).trim() + ' Billion ' + translate(n % 1000000000);
        }
        return word;
    }
    
    let result = translate(n);
    return (result.trim()).toUpperCase();
  }

  formatDate = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };

  render() {
    const { data, receiptIndex } = this.props;
    const receiptObj = receiptIndex===null ? { created_date : data.dateAt ,amount : data.paid  } : data?.receipts[receiptIndex] 

    return (
      <table
        style={{
          color: "black",
          width: "1000px",
          maxWidth: "900px",
          margin: "50px auto 70px",
          backgroundColor: "#fff",
          padding: "15px 20px",
          WebkitBorderRadius: "3px",
          MozBorderRadius: "3px",
          borderRadius: "3px",
          "WebkitBoxShadow":
            "0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)",
          borderCollapse: "collapse",
          borderSpacing: "0px",
          MozBoxShadow:
            "0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)",
          boxShadow: "0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)",
          borderTop: "solid 10px green",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                WebkitTextAlign: "left",
                textAlign: "left",
                padding: "9px 0px",
              }}
              colSpan={9}
            >
              <div
                className="top-bar"
                style={{
                  display: "flex",
                  gap: "165px",
                  WebkitAlignItems: "center",
                  WebkitBoxAlign: "center",
                  msFlexAlign: "center",
                  alignItems: "center",
                }}
              >
                <div className="top-image ">
                  <img
                    style={{ "maxWidth": "120px" }}
                    src="https://www.world2doorcargo.com/admin/assets/images/logo_dark.png"
                    alt="logo"
                  />
                </div>
                <div className="top-content ps-3">
                  <p
                    style={{
                      fontWeight: "700",
                      fontFamily: "CAVOLINIBOLD",
                      fontSize: "24px",
                      color: "#00b251",
                    }}
                  >
                    KENS WORLD2DOOR CARGO LLC
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ border: "1px solid black" }}>
            <td colSpan={9} style={{ padding: "0" }}>
              <table
                cellPadding={0}
                cellSpacing={0}
                style={{ width: "100%", "paddingTop": "0" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        padding: "0 15px",
                        WebkitTextAlign: "center",
                        textAlign: "center",
                        backgroundColor: "#a1bfa1",
                      }}
                      colSpan={2}
                    >
                      <h1
                        style={{
                          color: "#1e1e2d",
                          fontWeight: "700",
                          margin: "0",
                          fontSize: "18px",
                          fontFamily: "sans-serif",
                          padding: "14px 0",
                        }}
                      >
                        Payment Receipt
                      </h1>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td className="p-1">
              <p style={{lineHeight : 1.8}} className="mt-2">
                508, Dusseldorf Business Point Bldg, Al Barsha 1 <br />
                Dubai, DUBAI 454487 ARE <br />
                Kenneth.dsouza@world2door.com
              </p>
              <div className="d-flex mb-2 mt-4" style={{lineHeight : 1.8}}>
                <div className="col-sm-8">
                  <p className="mb-0">BILL TO</p>
                  <h6 className="fw-bold mb-0" style={{ color: "black" }}>
                    {data?.user?.user_full_name || "-"}
                  </h6>
                  <p className="mb-0">{data?.user?.user_email}</p>
                </div>
                <div className="col-sm-4">
                  <div className="d-flex justify-content-end">
                    <div>Date: {" "}</div>
                    <div>
                      {this.formatDate()}
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div>Job No. : {" "}</div>
                    {data?.job_token}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td
              colSpan={9}
              style={{ border: "1px solid black", padding: "0" }}
              className="mt-3"
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ width: "100%", textAlign: "center" }}>
                    <th
                      className="invoice-table-th"
                    >
                      SR
                    </th>
                    <th
                      className="invoice-table-th"
                      style={{ fontFamily: "system-ui" }}
                    >
                      Invoice Number
                    </th>
                    <th
                      className="invoice-table-th"
                      style={{ fontFamily: "system-ui" }}
                    >
                      Invoice Date
                    </th>
                    <th
                      className="invoice-table-th"
                      style={{ fontFamily: "system-ui" }}
                    >
                      Payment
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ width: "100%", textAlign: "center" }}>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        borderLeft: "0",
                      }}
                    >
                      1
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        // textAlign: "left",
                      }}
                    >
                      {data?.invoice_number || 0}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        // textAlign: "left",
                      }}
                    >
                      {receiptObj?.created_date ? moment(receiptObj.created_date).format("DD-MM-YYYY") : "-"}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        // textAlign: "left",
                      }}
                    >
                      {receiptObj?.amount || 0}
                    </td>
                  </tr>
                  <tr style={{ width: "100%", textAlign: "center" }}>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        borderLeft: "0",
                      }}
                      colSpan={2}
                    >
                      {/* 1 */}
                    </td>
                    {/* <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                      }}
                    >
                      {data?.invoice_number || 0}
                    </td> */}
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        // textAlign: "left",
                      }}
                    >
                      Total
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "3px 5px",
                        // textAlign: "left",
                      }}
                    >
                      {receiptObj?.amount || 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td
              colSpan={9}
              style={{ border: "1px solid black", padding: "0px 0" }}
            >
              <table
                cellPadding={0}
                cellSpacing={0}
                style={{ width: "100%", marginTop: "-4px" }}
              >
                <tbody style={{ borderTop: "0" }}>
                  <tr style={{ lineHeight: 2 }}>
                    <td colSpan={9} className="text-center p-2">
                    {/* <div
                        className="fw-bold fs-5 text-end"
                        style={{
                          color: "black",
                        }}
                      >
                        AED0.00
                      </div> */}
                    <div className="text-start mt-5">
                      In Words Received : UAE DIRHAMS{" "}
                        {(receiptObj?.amount &&
                          String(receiptObj.amount).split(".").length > 1 &&
                          this.numToWordsDhiram(
                            Number(String(receiptObj.amount).split(".")[0])
                          ) +
                            " AND " +
                            this.numToWordsDhiram(
                              Number(String(receiptObj.amount.toFixed(2)).split(".")[1])
                            ) +
                            " FILS ONLY") ||
                          this.numToWordsDhiram(
                            Number(String(receiptObj.amount).split(".")[0])
                          ) + " ONLY"
                          }

                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td
              colSpan={9}
              style={{ border: "1px solid black", padding: "3px 0" }}
            >
              <table
                cellPadding={0}
                cellSpacing={0}
                style={{ width: "100%", marginTop: "-4px" }}
              >
                <tbody style={{ borderTop: "0" }}>
                  <tr style={{ lineHeight: 2 }}>
                    <td
                      colSpan={9}
                      style={{
                        padding: "14px 0",
                        fontFamily: "system-ui",
                        fontSize: "14px",
                        "WebkitTextAlign": "center",
                        textAlign: "center",
                        borderTop: "1px solid #000000",
                        marginTop: "-4px",
                        position: "relative",
                      }}
                    >
                      ***This is a computer generated receipt and no signature
                      is required***
                      
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default InvoiceHtml;
